import Leaderboard from "./Leaderboard"

const Completed = (props) => {
  return (
    <main className="container">
      <section className="jumbotron">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h3>
              <span className="font-weight-bold">{props.user.score} </span>
              correct answers on{" "}
              <span
                className={
                  props.game.multiplier === 3
                    ? "text-danger"
                    : props.game.multiplier === 2
                    ? "text-warning"
                    : "text-success"
                }
              >
                {props.game.difficulty}
              </span>{" "}
              mode.
            </h3>
            <h3>
              Gives you{" "}
              <span className="font-weight-bold">
                {props.user.score * props.game.multiplier}
              </span>{" "}
              points.
            </h3>
            <h4>
              <a href={window.location.href}>Play again?</a>
            </h4>
          </div>
          <div className="col">
            <Leaderboard
              score={props.game.score}
              {...props.leaderboard}
              username={props.user.name}
            />
          </div>
        </div>
      </section>
    </main>
  )
}

export default Completed
